import { Dispatch } from "redux";
import { setAxnConfigRefreshResults, setAxnConfigRefreshing } from "@redux/actions/axn-config-actions";
import { refreshAxnConfigRequest } from "@requests/management-console/refresh-axn-config";
import { RefreshResult } from "@idw-types/common";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const refreshAxnConfigReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<RefreshResult>> => {
    dispatch(setAxnConfigRefreshResults(null, null));
    dispatch(setAxnConfigRefreshing(true));
    const { data, error } = await refreshAxnConfigRequest();

    const lastRefreshDate = new Date();

    if (data) {
        dispatch(setAxnConfigRefreshResults(data, lastRefreshDate));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.refreshAxnConfig.error.title,
                resources.requests.refreshAxnConfig.error.message
            );
        }
        dispatch(setAxnConfigRefreshResults(null, lastRefreshDate));
        return null;
    }
};